import { useApolloClient } from "@apollo/client";
import { useEnvContext } from "context/EnvContext";
import SealdContextProvider from "core/seald/SealdContext";
import { AppType } from "core/types";
import SpinnerPage, {
  SpinnerPageContainer,
} from "ds_legacy/components/Spinner";
import {
  useConnecterWithLoggedAccount,
  useOnLogout,
} from "reduxentities/hooks";

export default function WebSealdContextProvider({
  app,
  children,
}: {
  app: AppType;
  children: React.ReactNode;
}) {
  const loggedAccount = useConnecterWithLoggedAccount({ cacheOnly: true });
  const envContext = useEnvContext();
  const onLogout = useOnLogout();
  const client = useApolloClient();

  return (
    <SealdContextProvider
      apolloClient={client}
      app={app}
      envContext={envContext}
      Loading={
        <SpinnerPageContainer>
          <SpinnerPage id="seald-import-identify" />
        </SpinnerPageContainer>
      }
      loggedAccount={loggedAccount}
      onLogout={onLogout}
    >
      {children}
    </SealdContextProvider>
  );
}
